import React, { useState, useEffect, useRef } from 'react';
import T from 'prop-types';
import { createRoot } from 'react-dom/client';

import Carousel3D from '../../../components/Carousel3D';
import Slide from './components/Slide';
import useMobileView from '../сompetitive-intelligence-reports/shared/hooks/useMobileView';

const config = (isMobileView, setCurrentIndex) => ({
  variableWidth: isMobileView,
  centerMode: isMobileView,
  centerPadding: isMobileView ? '60px' : '0px',
  beforeChange: () => {
    setCurrentIndex(undefined);
  },
  afterChange: (newIndex) => {
    setCurrentIndex(newIndex);
  },
  infinite: true,
  speed: 500,
  fade: true,
  responsive: [
    {
      breakpoint: 960,
      settings: {
        speed: 500,
        dots: false,
        fade: false,
        arrows: false,
        autoplay: false,
        centerMode: true,
        centerPadding: '24px',
      },
    },
  ],
});

const ModelsChartsSlider = ({ dataChart }) => {
  const isMobileView = useMobileView();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [sliderInView, setSliderInView] = useState(false);
  const boxRef = useRef(null);


  const observer = new IntersectionObserver((query) => {
    setSliderInView(query[0].isIntersecting);
  },
  {
    root: null,
    rootMargin: '-30% 0px -30% 0px',
  });

  useEffect(() => {
    const { current } = boxRef;
    observer.observe(current);
    return () => {
      observer.unobserve(current);
    };
  }, [boxRef.current]);

  return (
    <div ref={boxRef}>
      <Carousel3D
        focusOnLoad
        className="models-hms-carousel3d"
        config={config(isMobileView, setCurrentIndex)}
        slides={[...Array(dataChart.length).keys()].map(slide => (
          <Slide
            key={slide}
            isActive={sliderInView && currentIndex === slide}
            data={dataChart[slide]}
          />
        ))}
      />
    </div>
  );
};
ModelsChartsSlider.propTypes = {
  dataChart: T.array,
};

document.addEventListener('DOMContentLoaded', () => {
  const rootNode = document.getElementById('models-slider-charts');
  if (rootNode) {
    const dataChart = JSON.parse(rootNode.dataset.financeCharts);
    const root = createRoot(rootNode);
    root.render(<ModelsChartsSlider dataChart={dataChart} />);
  }
});
